import { AutocompleteOption } from 'redesign';
import {
  SharedFiltersBranchOffice,
  SharedFiltersJobType,
} from 'partner/shared/services/partner-shared-service.types';
import { DepartmentOptions, ShiftPlanningFiltersData } from '../shift-planning-filters.types';
import { ShiftPlanningFilters } from '../../table/hooks/use-shift-planning-page.types';

export const checkBranchOfficesInCompany = (
  branchOfficeNames: string[],
  shiftPlanningFiltersData: ShiftPlanningFiltersData
): boolean => {
  const allBranchOfficeNames =
    shiftPlanningFiltersData.companies
      ?.flatMap((company) => company.branchOffices)
      .map((branchOffice) => branchOffice.branchOfficeName) || [];

  // Check if all branch office names are present
  return branchOfficeNames.every((name) => allBranchOfficeNames.includes(name));
};

export const getJobTypes = (
  appliedFilters: ShiftPlanningFilters,
  jobTypes: SharedFiltersJobType[]
) => {
  let cleanedJobTypes: AutocompleteOption[] | undefined = undefined;
  if (!appliedFilters) {
    return undefined;
  } else {
    const jobTypeUncleaned = appliedFilters.jobType?.map((jobTypeParamId) => {
      const data = jobTypes?.find((databaseJobType) => {
        return databaseJobType.id === jobTypeParamId;
      });
      if (data) {
        return { value: data.id, label: data.name } as AutocompleteOption;
      } else {
        return undefined;
      }
    });
    cleanedJobTypes = jobTypeUncleaned?.filter(
      (jobType): jobType is AutocompleteOption => jobType !== undefined
    );
    return cleanedJobTypes;
  }
};
export const getBranchOffices = (
  appliedBranchOfficeIds: string[] | undefined,
  branchOffices: SharedFiltersBranchOffice[]
): AutocompleteOption[] => {
  const options: AutocompleteOption[] = [];

  if (!appliedBranchOfficeIds?.length) {
    return options;
  }

  appliedBranchOfficeIds.forEach((branchOfficeParamId) => {
    const branchOffice = branchOffices.find((b) => b.branchOfficeId === branchOfficeParamId);

    if (branchOffice) {
      options.push({
        value: branchOffice.branchOfficeId,
        label: branchOffice.branchOfficeName,
      });
    }
  });

  return options;
};

export const getDepartments = (
  appliedDepartmentIds: string[] | undefined,
  branchOffices: SharedFiltersBranchOffice[]
): DepartmentOptions[] => {
  if (!appliedDepartmentIds?.length) {
    return [];
  }
  const allDepartments: DepartmentOptions[] = branchOffices.flatMap((b) =>
    b.departments.map((d) => ({
      value: d.departmentId,
      label: d.departmentName,
      branchOfficeName: b.branchOfficeName,
    }))
  );

  return appliedDepartmentIds
    .map((deptId) => allDepartments.find((d) => d.value === deptId))
    .filter((d): d is DepartmentOptions => !!d);
};
